import { render, staticRenderFns } from "./FileConfigRoleModal.vue?vue&type=template&id=1f3e5d97&"
import script from "./FileConfigRoleModal.vue?vue&type=script&lang=js&"
export * from "./FileConfigRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports